import { DataItemType } from "../../schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
import pc from "./components/pc.vue";
const info = {
    title: "Task Marker",
    type: "taskMarker",
    icon: "",
    dataItemType: DataItemType.LongText,
    formControllerType: 21,
    group: "拓展控件",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
        pc,
    },
};
